import React, { Component } from 'react';
import { Link } from 'react-router-dom';
import Header from '../components/header';
import Sidebar from '../components/sidebar';


function iosDevice() {
    var userAgent = window.navigator.userAgent;
    if (userAgent.match(/iPad/i) || userAgent.match(/iPhone/i)) {
        return true;
    }
    else {
        return false;
    }
}


export const DefaultLayout = (Wrapped) => (props) => {
    console.log(props[0].location.pathname)
    const showLayout = props[0].location.pathname !== '/login' && props.uData;
    return (
        <div className={showLayout ? (props.sidebarShort ? 'main-layout sidebar-collapsed' : 'main-layout') : ''} style={typeof window != 'undefined' && iosDevice() ? { maxWidth: `${window.innerWidth}px` } : {}}>
            {showLayout ? <Sidebar {...props}></Sidebar> : null}
            {showLayout ? <Header {...props} /> : null}
            <div className={showLayout ? 'main-content' : ''}>
                <Wrapped {...props} />
            </div>
        </div>
    );
};

export default DefaultLayout;